var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C19.6819 16 22.6666 13.0152 22.6666 9.33332C22.6666 5.65142 19.6819 2.66666 16 2.66666C12.3181 2.66666 9.33331 5.65142 9.33331 9.33332C9.33331 13.0152 12.3181 16 16 16Z",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54657 29.3333C4.54657 24.1733 9.6799 20 15.9999 20C17.2799 20 18.5199 20.1733 19.6799 20.4933",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 24C29.3334 25 29.0534 25.9467 28.56 26.7467C28.28 27.2267 27.92 27.6533 27.5067 28C26.5734 28.84 25.3467 29.3333 24 29.3333C22.0534 29.3333 20.36 28.2933 19.44 26.7467C18.9467 25.9467 18.6667 25 18.6667 24C18.6667 22.32 19.44 20.8133 20.6667 19.84C21.5867 19.1067 22.7467 18.6667 24 18.6667C26.9467 18.6667 29.3334 21.0533 29.3334 24Z",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9199 24L23.2398 25.32L26.0799 22.6934",
    stroke: "#A58CB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUserCheck);
export default __webpack_public_path__ + "static/media/invite_user_check.2fd8c2e87e5857de6e9a6672e14ca554.svg";
export { ForwardRef as ReactComponent };